import { Modal, Input, Typography, Tooltip } from "antd";
import PropTypes from "prop-types";
import { ExclamationCircleFilled, InfoCircleOutlined } from "@ant-design/icons";
import { useCustomToolStore } from "../../../store/custom-tool-store";
import SpaceWrapper from "../../../components/widgets/space-wrapper/SpaceWrapper";
import { useState } from "react";
import { CloneFooter } from "../clone-footer/CloneFooter.jsx";
import "./CloneTitle.css";

function CloneTitle({ open, setOpenCloneModal }) {
  const { details } = useCustomToolStore();
  const [toolName, setToolName] = useState(`Copy of ${details?.tool_name}`);

  const handleTitleChange = (e) => {
    const titleText = e.target.value;
    setToolName(titleText);
  };
  const handleClose = () => {
    setOpenCloneModal(false);
  };

  return (
    <SpaceWrapper>
      <Modal
        open={open}
        title={
          <div className="clone-title">
            <ExclamationCircleFilled
              className="clone-icons"
              style={{ fontSize: "16px", color: "#FAAD14" }}
            />
            <Typography.Text className="clone-typography-title">
              Enter name for your new clone
            </Typography.Text>
          </div>
        }
        onCancel={handleClose}
        centered={true}
        closable={true}
        maskClosable={true}
        keyboard={true}
        footer={
          <CloneFooter
            toolName={toolName}
            setOpenCloneModal={setOpenCloneModal}
          />
        }
      >
        <div className="clone-info">
          <Input
            size="default"
            value={toolName}
            onChange={handleTitleChange}
            suffix={
              <Tooltip title="Name of the clone">
                <InfoCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
              </Tooltip>
            }
          />
        </div>
      </Modal>
    </SpaceWrapper>
  );
}

CloneTitle.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpenCloneModal: PropTypes.func.isRequired,
};

export { CloneTitle };
